module.exports = __webpack_public_path__ + "img/logo.18736d09.svg";